import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setTipValue } from "../../store/slices/IdSlice";

const Tips: React.FC = () => {
  const dispatch = useDispatch();
  const [selectedTip, setSelectedTip] = useState<string | number | null>(null);
  const [customTip, setCustomTip] = useState("");
  const customTipInputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (selectedTip === "custom" && customTipInputRef.current) {
      customTipInputRef.current.focus();
    }
  }, [selectedTip]);

  const tipValues = sessionStorage.getItem("tipValue");
  useEffect(() => {
    if (
      Number(tipValues) === 10 ||
      Number(tipValues) === 15 ||
      Number(tipValues) === 20
    ) {
      setSelectedTip(Number(tipValues).toString());
    } else if (Number(tipValues) > 0) {
      setSelectedTip("custom");
      setCustomTip(Number(tipValues).toString());
    } else {
      setSelectedTip(null);
      setCustomTip("");
    }
  }, [tipValues]);

  const handleTipClick = (amount: string | number) => {
    const isSameSelected = selectedTip?.toString() === amount.toString();
    if (isSameSelected) {
      setSelectedTip(null);
      setCustomTip("");
      dispatch(setTipValue(0));
      sessionStorage.setItem("tipValue", "0");
      return;
    }

    if (amount === "custom") {
      setSelectedTip("custom");
    } else {
      setSelectedTip(amount.toString());
      setCustomTip(""); // Clear custom
      dispatch(setTipValue(Number(amount)));
      sessionStorage.setItem("tipValue", JSON.stringify(amount));
    }
  };
  const handleCustomTipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCustomTip(value);
    const numericValue = Number(value);
    if (!isNaN(numericValue) && numericValue >= 5) {
      sessionStorage.setItem("tipValue", JSON.stringify(numericValue));
      dispatch(setTipValue(numericValue));
    } else {
      dispatch(setTipValue(0));
    }
  };

  return (
    <div className="payment-summary-container p-4 mb-2 d-none">
      <div>
        <div className="font-14 ff-semibold mt-2 mb-3">
          Add a tip to thank the Professional
        </div>
        <div className="tip-selector d-flex justify-content-start gap-3">
          {/* Preset Tip Options */}
          {[10, 15, 20].map((tip) => (
            <div
              key={tip}
              className={`tip-option d-flex position-relative align-items-center justify-content-center flex-row ff-medium ${
                tip == 15 ? "popular" : ""
              } ${selectedTip == tip ? "selected" : ""}`}
              onClick={() => handleTipClick(tip)}
            >
              {tip === 15 && <div className="popular-green">Popular</div>}
              <p className="tip-currency ">
                <span className="ff-currency ff-medium font-16"></span>
              </p>
              <p className="tip-amount ">{tip}</p>
            </div>
          ))}

          {/* Custom Tip Option */}
          <div
            className={`tip-option ${
              selectedTip === "custom" ? "selected" : ""
            }`}
            onClick={() => handleTipClick("custom")}
          >
            {selectedTip === "custom" ? (
              <div className="d-flex align-items-center justify-content-start gap-1 ff-medium">
                <span className="ff-currency ff-medium font-16"></span>
                <input
                  ref={customTipInputRef} // Attach the ref here
                  type="number"
                  min="5"
                  value={customTip}
                  onChange={handleCustomTipChange}
                  className="custom-tip-input bg-none border-0"
                />
              </div>
            ) : (
              <p className="tip-custom-label ff-medium">Custom</p>
            )}
          </div>
        </div>
        {selectedTip === "custom" &&
          Number(customTip) < 5 &&
          Number(customTip) != 0 && (
            <div className="error-text font-10 text-danger text-start mt-1 ff-medium">
              Minimum Amount{" "}
              <span className="ff-currency ff-medium font-16"></span> 5
            </div>
          )}

        <div className="font-11 ff-medium mt-3 text-black-50">
          100% of the tip goes to the professional.
        </div>
      </div>
    </div>
  );
};

export default Tips;
